import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { PickerButton } from '../../atoms';

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 6px;
`;

const PeriodPicker = ({ period, setPeriod }) => (
  <StyledContainer>
    <PickerButton onClick={() => setPeriod('Day')} label='Day' period={period} value='Day' />
    <PickerButton onClick={() => setPeriod('Week')} label='Week' period={period} value='Week' />
    <PickerButton onClick={() => setPeriod('Month')} label='Month' period={period} value='Month' />
  </StyledContainer>
);

PeriodPicker.propTypes = {
  period: PropTypes.string.isRequired,
  setPeriod: PropTypes.func.isRequired
};

export { PeriodPicker };
